import { useEffect, useState } from 'react';

export const DubaiClock = ({ dark = false }) => {
  const [time, setTime] = useState('--:--:--');

  useEffect(() => {
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
    const tick = () => setTime(fmt.format(new Date()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="dubai-time-clock"
      className={`flex items-center gap-2.5 text-[11px] tracking-[0.22em] font-medium ${dark ? 'text-cream/60' : 'text-ink/55'}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-royal opacity-60" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-royal" />
      </span>
      DUBAI&nbsp;{time}&nbsp;GST
    </div>
  );
};
